export default "Suramortissement fiscal (art. 39 quinquies AA CGI) pour investissements énergétiques : conditions d'éligibilité, cumuls possibles avec primes CEE tertiaires.";
